<div class="workspace no-back-btn" [ngClass]="{'no-bottom-bar': isHideBottomBar() }">
  <div class="row" id="campaign_new">
    <div class="col-md-12">
      <div class="campaign-container campaign-tab-header d-flex flex-column justify-content-center">
        <div class="head d-flex flex-row justify-content-center">
          <div class="spacer flex-fill"></div>
          <div class="head-menu">
            <hr class="bottom-line" />
            <div class="items">
              <span [ngClass]="{'selected': isCampaignTabSelected()}"
                    (click)="setCampaingSelected()">
                {{'campaigns.new_campaign.campaign' | translate}}
              </span>
              <span *ngIf="isActivatedAdvertiserChat() && campaign"
                    [ngClass]="{'selected': isChatTabSelected()}"
                    (click)="setChatTabSelected()">
                {{'campaigns.new_campaign.advertiser_chat' | translate}}
              </span>
            </div>
          </div>
          <div class="spacer flex-fill"></div>
        </div>
      </div>
      <div class="row flex-row justify-content-center d-none d-sm-none d-md-flex progress-container" *ngIf="campaign">
        <div class="col-md-8 campaign-progress">
          <campaign-status-slider [slider]="campaignSlider" [readonly]="'true'"></campaign-status-slider>
        </div>
      </div>
      <div class="row d-flex flex-row justify-content-center campaign-details-container">
        <div class="col-md-8" *ngIf="isCampaignTabSelected()">
          <campaign-details [campaign]="campaign"
                            [isLandingPageMode]="isLandingPageMode"
                            [isDeletedOrError]="isDeletedOrError"
                            (openContactEvt)="setChatTabSelected()"
                            (declineCallback)="onDeclineCampaign(true)"
                            (acceptInvitation)="onAcceptCampaign()">
          </campaign-details>
        </div>
        <div class="col-md-8" *ngIf="isChatTabSelected() && conversation">
          <div class="chat-container">
            <influencer-chat [conversation]="conversation" [showActivityLog]="showActivityLog"></influencer-chat>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bottom-bar" *ngIf="showBottomBar">
  <div class="buttons">
    <button class="button gray" (click)="exportPDF()" *ngIf="isEnableExportButton()">{{'common.btn.export' | translate}}</button>
    <button class="button gray" (click)="back()">{{'common.btn.back' | translate}}</button>
    <button class="button cerise-red" (click)="onDeclineCampaign()" *ngIf="isShowButtonDecline()">{{'common.btn.decline' | translate}}</button>
    <button class="button green" (click)="onAcceptCampaign()" *ngIf="isShowButtonAccept()">{{'common.btn.accept' | translate}}</button>
  </div>
</div>
<achoo-popup #AlertPdfDownloadPending
             [isNotification]="true"
             modelTitle="{{'common.alert' | translate}}"
             (acceptCallback)="closeNotification()"
             (cancelCallback)="closeNotification()">
  <span>{{'pdf.pending_message' | translate}}</span>
</achoo-popup>
<achoo-popup #WarningFailToRetrieveCampaign [isSpecialPopup]="true">
  <fail-retrieve-campaign-modal *ngIf="errorType"
                                [errorType]="errorType"
                                [showTryAgainButton]="isShowRetryButton(errorType)"
                                (tryAgain)="tryAgainHandler(errorType)">
  </fail-retrieve-campaign-modal>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/campaign-new/campaign-new.component.html